// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2yRS9","title":"Header_title__S6sXs","side":"Header_side__1zm44"};